let activeNotes = 0;

const note = (message) => {
    let notes = document.querySelector('.rit-notes');

    if (!notes) {
        notes = document.createElement('div');
        notes.classList.add('rit-notes');
    }

    if( '' === message ) {
        return;
    }

    const note = document.createElement('div');
    const inner = document.createElement('div');
    const text = document.createElement('p');
    note.classList.add('rit-note');
    inner.classList.add('rit-note__inner', 'info');
    text.classList.add('rit-note__text');
    text.innerHTML = message;
    inner.appendChild(text);
    note.appendChild(inner);
    notes.appendChild(note);

    const siteMain = document.querySelector('body');
    if (siteMain && !document.querySelector('.rit-notes')) {
        siteMain.appendChild(notes);
    }

    activeNotes++;

    setTimeout(() => {
        note.remove();
        activeNotes--;

        if (activeNotes === 0) {
            notes.remove();
        }
    }, 3000);
}

export default note;